import React from "react";

function Agreement() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.h1}>
          Лицензионное соглашение конечного пользователя (EULA)
        </h1>
        <p style={styles.updated}>Дата последнего обновления: 26 мая 2024 г.</p>

        <p style={styles.p}>
          Пожалуйста, внимательно ознакомьтесь с данным Лицензионным соглашением
          перед нажатием кнопки «Я согласен», загрузкой или использованием
          приложения <strong>Виртуальная АТС V-office</strong>.
        </p>

        <h2 style={styles.h2}>Толкование и определения</h2>

        <h3 style={styles.h3}>Толкование</h3>
        <p style={styles.p}>
          Слова, начинающиеся с заглавной буквы, имеют значения, определённые
          ниже. Эти определения применяются как в единственном, так и во
          множественном числе.
        </p>

        <h3 style={styles.h3}>Определения</h3>
        <p style={styles.p}>
          <strong>Соглашение</strong> — настоящее Лицензионное соглашение
          конечного пользователя, регулирующее использование Приложения.
        </p>
        <p style={styles.p}>
          <strong>Приложение</strong> — программное обеспечение{" "}
          <strong>Виртуальная АТС V-office</strong>, предоставляемое Компанией и загружаемое
          Пользователем на Устройство.
        </p>
        <p style={styles.p}>
          <strong>Компания</strong> — <strong>IT-SPARK LLC</strong>, Армения,
          0078, г. Ереван, ул. Алабяна, д. 65/5, 1-й этаж.
        </p>
        <p style={styles.p}>
          <strong>Контент</strong> — любые материалы, включая текст, изображения
          и иную информацию, которые могут быть размещены, загружены,
          опубликованы или иным образом предоставлены Пользователем.
        </p>
        <p style={styles.p}>
          <strong>Страна</strong> — Республика Армения.
        </p>
        <p style={styles.p}>
          <strong>Устройство</strong> — любое устройство, которое может получить
          доступ к Приложению, включая компьютер, мобильный телефон или
          планшет.
        </p>
        <p style={styles.p}>
          <strong>Сторонние сервисы</strong> — любые сервисы или контент третьих
          лиц, включая данные, приложения, продукты и услуги, которые могут
          отображаться, включаться или предоставляться через Приложение.
        </p>
        <p style={styles.p}>
          <strong>Вы / Пользователь</strong> — физическое лицо, использующее
          Приложение, либо компания или иное юридическое лицо, от имени которого
          такое лицо использует Приложение.
        </p>

        <h2 style={styles.h2}>Принятие условий</h2>
        <p style={styles.p}>
          Нажимая кнопку «Я согласен», загружая или используя Приложение, Вы
          подтверждаете своё согласие соблюдать условия настоящего Соглашения.
        </p>
        <p style={styles.p}>
          Если Вы не согласны с условиями настоящего Соглашения, не нажимайте
          кнопку «Я согласен», не загружайте и не используйте Приложение.
        </p>
        <p style={styles.p}>
          Настоящее Соглашение является юридически обязательным документом между
          Вами и Компанией и регулирует использование Приложения,
          предоставленного Вам Компанией.
        </p>
        <p style={styles.p}>
          Приложение предоставляется Вам по лицензии, а не продаётся, и может
          использоваться только в соответствии с условиями настоящего
          Соглашения.
        </p>

        <h2 style={styles.h2}>Лицензия</h2>
        <h3 style={styles.h3}>Объём лицензии</h3>
        <p style={styles.p}>
          Компания предоставляет Вам отзывную, неисключительную, непередаваемую,
          ограниченную лицензию на загрузку, установку и использование
          Приложения строго в соответствии с условиями настоящего Соглашения.
        </p>
        <p style={styles.p}>
          Лицензия предоставляется исключительно для Вашего личного
          некоммерческого использования, если иное не согласовано отдельно с
          Компанией.
        </p>

        <h2 style={styles.h2}>Сторонние сервисы</h2>
        <p style={styles.p}>
          Приложение может отображать, включать или предоставлять контент
          третьих лиц, а также содержать ссылки на сторонние веб-сайты и
          сервисы.
        </p>
        <p style={styles.p}>
          Вы признаёте и соглашаетесь, что Компания не несёт ответственности за
          любые Сторонние сервисы, включая их точность, полноту,
          своевременность, актуальность, соответствие законодательству, качество
          и иные характеристики.
        </p>
        <p style={styles.p}>
          Компания не принимает на себя никаких обязательств и не несёт
          ответственности перед Вами или третьими лицами в отношении любых
          Сторонних сервисов.
        </p>
        <p style={styles.p}>
          При использовании Приложения Вы обязаны соблюдать применимые условия
          использования соответствующих Сторонних сервисов.
        </p>
        <p style={styles.p}>
          Сторонние сервисы и ссылки на них предоставляются исключительно для
          удобства Пользователя, и Вы используете их на свой страх и риск,
          руководствуясь условиями и правилами соответствующих третьих лиц.
        </p>

        <h2 style={styles.h2}>Срок действия и прекращение</h2>
        <p style={styles.p}>
          Настоящее Соглашение действует до тех пор, пока не будет прекращено
          Вами или Компанией.
        </p>
        <p style={styles.p}>
          Компания вправе по своему усмотрению в любое время приостановить или
          прекратить действие настоящего Соглашения с предварительным
          уведомлением или без него.
        </p>
        <p style={styles.p}>
          Настоящее Соглашение прекращается немедленно без предварительного
          уведомления со стороны Компании, если Вы нарушаете любое из его
          положений.
        </p>
        <p style={styles.p}>
          Вы также вправе прекратить действие Соглашения, удалив Приложение и
          все его копии со своего Устройства или компьютера.
        </p>
        <p style={styles.p}>
          После прекращения действия Соглашения Вы обязаны прекратить
          использование Приложения и удалить все его копии.
        </p>
        <p style={styles.p}>
          Прекращение действия настоящего Соглашения не ограничивает никакие
          права и средства правовой защиты Компании по закону или по праву
          справедливости в случае нарушения Вами Ваших обязательств в период
          действия Соглашения.
        </p>

        <h2 style={styles.h2}>Возмещение убытков</h2>
        <p style={styles.p}>
          Вы соглашаетесь защищать, возмещать убытки и ограждать Компанию, её
          материнские, дочерние и аффилированные компании, должностных лиц,
          сотрудников, агентов, партнёров и лицензиаров (при наличии) от любых
          претензий, требований, убытков, расходов и издержек, включая разумные
          расходы на юридическую помощь, возникающих в связи с:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>использованием Вами Приложения;</li>
          <li style={styles.li}>
            нарушением Вами условий настоящего Соглашения, закона или
            нормативных требований;
          </li>
          <li style={styles.li}>нарушением Вами прав третьих лиц.</li>
        </ul>

        <h2 style={styles.h2}>Отказ от гарантий</h2>
        <p style={styles.p}>
          Приложение предоставляется по принципу{" "}
          <strong>«КАК ЕСТЬ» (AS IS)</strong> и{" "}
          <strong>«ПРИ НАЛИЧИИ» (AS AVAILABLE)</strong>, со всеми возможными
          недостатками и без каких-либо гарантий.
        </p>
        <p style={styles.p}>
          В максимально допустимой законом степени Компания от своего имени, а
          также от имени своих аффилированных лиц, лицензиаров и поставщиков
          услуг, прямо отказывается от любых гарантий, прямо выраженных,
          подразумеваемых, предусмотренных законом или иных, включая гарантии
          товарной пригодности, пригодности для определённой цели, правового
          титула и ненарушения прав.
        </p>
        <p style={styles.p}>Компания не гарантирует, что Приложение:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>будет соответствовать Вашим требованиям;</li>
          <li style={styles.li}>достигнет ожидаемых результатов;</li>
          <li style={styles.li}>
            будет совместимо с иным программным обеспечением, приложениями,
            системами или сервисами;
          </li>
          <li style={styles.li}>
            будет работать без перерывов, задержек и ошибок;
          </li>
          <li style={styles.li}>
            будет соответствовать каким-либо стандартам производительности или
            надёжности;
          </li>
          <li style={styles.li}>
            будет свободно от дефектов, а ошибки будут исправлены.
          </li>
        </ul>
        <p style={styles.p}>
          Без ограничения вышеизложенного, ни Компания, ни какой-либо поставщик
          Компании не делает никаких заявлений и не предоставляет гарантий,
          прямо выраженных или подразумеваемых:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            в отношении работы или доступности Приложения, а также информации,
            контента, материалов или продуктов, размещённых в нём;
          </li>
          <li style={styles.li}>
            что работа Приложения будет бесперебойной и безошибочной;
          </li>
          <li style={styles.li}>
            в отношении точности, надёжности или актуальности любой информации
            или контента, предоставляемых через Приложение;
          </li>
          <li style={styles.li}>
            что Приложение, его серверы, контент или электронные письма,
            отправленные от имени Компании, не содержат вирусов, скриптов,
            троянов, червей, вредоносного ПО, тайм-бомб или иных вредоносных
            компонентов.
          </li>
        </ul>
        <p style={styles.p}>
          Некоторые юрисдикции не допускают исключения определённых видов
          гарантий или ограничения применимых законных прав потребителя, поэтому
          некоторые или все вышеуказанные исключения и ограничения могут к Вам
          не применяться. Однако в таком случае ограничения и исключения,
          предусмотренные настоящим разделом, применяются в максимально
          допустимой законом степени.
        </p>
        <p style={styles.p}>
          В той мере, в какой какая-либо гарантия существует в силу закона и не
          может быть исключена, Компания несёт ответственность только в пределах,
          прямо установленных таким законом.
        </p>

        <h2 style={styles.h2}>Ограничение ответственности</h2>
        <p style={styles.p}>
          Независимо от размера возможных убытков, общая ответственность
          Компании и её поставщиков по любым положениям настоящего Соглашения, а
          также Ваше исключительное средство правовой защиты, ограничиваются
          суммой, фактически уплаченной Вами за Приложение или через Приложение,
          либо <strong>100 (сто) долларов США</strong>, если Вы не производили
          оплату.
        </p>
        <p style={styles.p}>
          В максимально допустимой законом степени Компания и её поставщики не
          несут ответственности за любые специальные, случайные, косвенные или
          последующие убытки, включая, помимо прочего:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>убытки от потери прибыли;</li>
          <li style={styles.li}>потерю данных или иной информации;</li>
          <li style={styles.li}>перерывы в хозяйственной деятельности;</li>
          <li style={styles.li}>телесные повреждения;</li>
          <li style={styles.li}>утрату конфиденциальности;</li>
          <li style={styles.li}>
            невозможность использования Приложения, стороннего ПО и/или
            оборудования, используемого совместно с Приложением;
          </li>
          <li style={styles.li}>
            любые иные убытки, возникающие из использования или невозможности
            использования Приложения.
          </li>
        </ul>
        <p style={styles.p}>
          Указанное ограничение действует даже в том случае, если Компания или
          её поставщик были уведомлены о возможности таких убытков, и даже если
          средство правовой защиты не достигло своей основной цели.
        </p>
        <p style={styles.p}>
          Некоторые штаты или юрисдикции не допускают исключения или ограничения
          ответственности за случайные или последующие убытки, поэтому некоторые
          из вышеуказанных ограничений могут к Вам не применяться.
        </p>

        <h2 style={styles.h2}>Делимость и отказ от прав</h2>

        <h3 style={styles.h3}>Делимость</h3>
        <p style={styles.p}>
          Если какое-либо положение настоящего Соглашения будет признано
          неисполнимым или недействительным, такое положение подлежит изменению
          и толкованию таким образом, чтобы в максимально возможной степени
          достичь целей данного положения в соответствии с применимым
          законодательством, а остальные положения сохраняют полную силу и
          действие.
        </p>

        <h3 style={styles.h3}>Отказ от прав</h3>
        <p style={styles.p}>
          За исключением случаев, прямо предусмотренных настоящим Соглашением,
          неосуществление какого-либо права или неисполнение требования об
          исполнении какого-либо обязательства по настоящему Соглашению не
          влияет на возможность осуществления такого права или требования в
          дальнейшем и не означает отказ от права на предъявление претензий в
          отношении последующего нарушения.
        </p>

        <h2 style={styles.h2}>Претензии к продукту</h2>
        <p style={styles.p}>
          Компания не предоставляет никаких дополнительных гарантий в отношении
          Приложения.
        </p>

        <h2 style={styles.h2}>Соблюдение законодательства США</h2>
        <p style={styles.p}>Вы заявляете и гарантируете, что:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            Вы не находитесь в стране, на которую распространяется эмбарго
            правительства США или которая признана правительством США страной,
            поддерживающей терроризм;
          </li>
          <li style={styles.li}>
            Вы не включены ни в один из списков запрещённых или ограниченных лиц
            правительства США.
          </li>
        </ul>

        <h2 style={styles.h2}>Изменения в настоящем Соглашении</h2>
        <p style={styles.p}>
          Компания оставляет за собой право по собственному усмотрению изменять
          или заменять настоящее Соглашение в любое время.
        </p>
        <p style={styles.p}>
          В случае существенных изменений Компания уведомит Вас как минимум за
          30 дней до вступления новых условий в силу. Что считается существенным
          изменением, определяется Компанией по собственному усмотрению.
        </p>
        <p style={styles.p}>
          Продолжая использовать Приложение после вступления изменений в силу,
          Вы соглашаетесь соблюдать обновлённые условия. Если Вы не согласны с
          новыми условиями, Вы должны прекратить использование Приложения.
        </p>

        <h2 style={styles.h2}>Применимое право</h2>
        <p style={styles.p}>
          Настоящее Соглашение регулируется законодательством Республики Армения
          без учёта коллизионных норм.
        </p>
        <p style={styles.p}>
          Использование Вами Приложения также может подпадать под действие иных
          местных, государственных, национальных или международных законов.
        </p>

        <h2 style={styles.h2}>Полное соглашение</h2>
        <p style={styles.p}>
          Настоящее Соглашение представляет собой полное соглашение между Вами и
          Компанией в отношении использования Приложения и заменяет собой все
          предыдущие и текущие письменные или устные соглашения между Вами и
          Компанией по данному предмету.
        </p>
        <p style={styles.p}>
          При использовании других сервисов Компании или покупке дополнительных
          услуг к Вам могут применяться дополнительные условия, которые Компания
          предоставит Вам в момент такого использования или покупки.
        </p>

        <h2 style={styles.h2}>Связаться с нами</h2>
        <p style={styles.p}>
          Если у Вас есть вопросы по настоящему Соглашению, Вы можете связаться
          с нами:
        </p>

        <div style={styles.contactBox}>
          <p style={styles.contactItem}>
            <strong>Email:</strong> info@ats.am
          </p>
          <p style={styles.contactItem}>
            <strong>Сайт:</strong>{" "}
            <a
              href="https://it-spark.am/"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              https://it-spark.am/
            </a>
          </p>
          <p style={styles.contactItem}>
            <strong>Телефон:</strong> +37444720101
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#f5f7fb",
    minHeight: "100vh",
    padding: "32px 16px",
  },
  container: {
    maxWidth: "960px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "32px",
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    fontFamily: "Arial, sans-serif",
    color: "#1f2937",
    lineHeight: 1.7,
  },
  h1: {
    fontSize: "30px",
    marginBottom: "8px",
    color: "#111827",
  },
  h2: {
    fontSize: "22px",
    marginTop: "30px",
    marginBottom: "12px",
    color: "#111827",
    borderBottom: "1px solid #e5e7eb",
    paddingBottom: "6px",
  },
  h3: {
    fontSize: "18px",
    marginTop: "20px",
    marginBottom: "10px",
    color: "#1f2937",
  },
  updated: {
    color: "#6b7280",
    fontSize: "14px",
    marginBottom: "20px",
  },
  p: {
    margin: "10px 0",
    fontSize: "16px",
  },
  ul: {
    margin: "10px 0 10px 22px",
    padding: 0,
  },
  li: {
    marginBottom: "8px",
    fontSize: "16px",
  },
  contactBox: {
    marginTop: "12px",
    padding: "18px",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
  },
  contactItem: {
    margin: "8px 0",
    fontSize: "16px",
  },
  link: {
    color: "#2563eb",
    textDecoration: "none",
  },
};

export default Agreement;